import React, { useEffect, useState } from "react"
import {
    AlertType, LanctoFormaPag, ParamsEstDupReceber, classBorderLabelDark, classBt, classInput, classInputDark, classLabel,
    classLabelDark, classbtAzul, classbtColunasVermelho
} from "../../Utils/Types"
import { Funcoes } from "../../Utils/Funcoes"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { ContaAReceberService } from "../../Pages/ContasAReceber/ContaAReceberService"
import estorno from '../../assets/imagens/estornoReceber.png'
import { selectUser } from "../Redux/userSlice"
import { useSelector } from "react-redux"

export type Props = {
    visible: boolean,
    totSelecionado: number,
    qtdDupSelecionado: number,
    handleModalClose: () => void,
    handleConfirm: () => Promise<boolean>,
    dupSelectedList: number[],
    bordero: number[]
}

interface Pagamento {
    id_fpagto: number;
    valor: number;
    description: string;
}

export const ModalEstornarDupReceber = React.memo(({ visible, totSelecionado, dupSelectedList, qtdDupSelecionado, handleModalClose, handleConfirm, bordero }: Props) => {

    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [visibleMsg, setVisibleMsg] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // -----------------------------------------------
    // ---------- ATRIBUTOS  -------------------------
    // -----------------------------------------------
    const [senhaUsuario, setSenhaUsuario] = useState("")
    const [motivo, setMotivo] = useState("")

    // -----------------------------------------------
    // ---------- ATRIBUTOS LANCAMENTO CONTAS --------
    // -----------------------------------------------
    const [lanctoFormaPagList, setLanctoFormaPagList] = useState<LanctoFormaPag[]>([])

    // -----------------------------------------------
    // ---------- ATRIBUTOS TEMA ---------------------
    // -----------------------------------------------
    const [tema, setTema] = useState("")
    let user = useSelector(state => selectUser(state))

    //------------------------------------------------------------------- ATRIBUTOS E EFFECT ------------------------------------------------------------------------||
    const getContaPagamento = async () => {
        setLoading(true)
        try {

            const resp = await ContaAReceberService.BuscarPagamentos(dupSelectedList);

            const agrupado: { [key: string]: Pagamento } = {};

            // Agrupar por id_fpagto e somar valores
            for (let i = 0; i < resp.data.length; i++) {
                const item = resp.data[i];
                const id = item.id_fpagto;

                if (!agrupado[id]) {
                    agrupado[id] = { ...item }; // copia o item inteiro
                } else {
                    agrupado[id].valor += item.valor; // soma os valores
                }
            }

            // Transformar o objeto agrupado em array
            const listaProcessada = Object.values(agrupado);

            setLanctoFormaPagList(listaProcessada);

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível obter as formas de pagamento`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {

        if (visible) {

            getContaPagamento()

            let modal = document.getElementById('modal_duplicata_estornar_receber')
            let modalContent = document.getElementById('modal_content_duplicata_estornar_receber')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_duplicata_estornar_receber')
            let modalContent = document.getElementById('modal_content_duplicata_estornar_receber')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]')
                    modalContent.classList.remove('mt-24')
                }
            }
        }

    }, [visible])

    useEffect(() => {
        setTema(user.modeDark)
    }, [user.modeDark])

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    //--------------------------------------------------------------------------------------------- INPUTS ------------------------------------------------------------------------------------------//
    const handleChangeSenhaUsuario = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSenhaUsuario(e.target.value)
    }

    const handleChangeMotivo = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMotivo(e.target.value)
    }

    //---------------------------------------------------------------------------------------------  ESTORNAR DUPLICATAS RECEBER ------------------------------------------------------------------------------------------//
    const handleLiquidarDuplicata = async () => {

        setVisibleMsg(false)
        setLoading(true)

        try {

            let totFormaPag = 0
            lanctoFormaPagList.map(item => totFormaPag += item.valor)

            const parametros: ParamsEstDupReceber = {
                senha_usuario: '',
                duplicatas: [],
                pagamentos: lanctoFormaPagList,
                bordero: [],
                motivo: ''
            }

            parametros.senha_usuario = senhaUsuario
            parametros.bordero = bordero
            parametros.motivo = motivo

            const retAPI = await ContaAReceberService.Estornar(parametros)

            if (retAPI.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || '')

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage(`Estorno da(s) duplicata(s) concluído com sucesso`)

                const dados = await handleConfirm()

                if (dados) {
                    const aguarde = setTimeout(() => {
                        handleModalClose()
                        clearFields()
                        clearTimeout(aguarde)
                    }, 250)
                }

            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível estornar a(s) duplicata(s). Por favor, tente novamente`)

        } finally {
            setLoading(false)
        }
    }

    const clearFields = () => {

        setSenhaUsuario('')
        setMotivo('')
        setLanctoFormaPagList([])
    }

    const fecharModal = () => {

        setVisibleMsg(false)
        handleModalClose()

        setSenhaUsuario('')
        setMotivo('')
        setLanctoFormaPagList([])
    }

    return (

        <div id="modal_duplicata_estornar_receber" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 bg-white`}>

            <div id="modal_content_duplicata_estornar_receber" className={`relative flex flex-col w-[90%] xl:w-[70%] 2xl:w-[60%] h-[510px] bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center bg-slate-200 dark:bg-slate-600 rounded-t-lg`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>

                        <img src={estorno} alt="" style={{ width: '25px', height: '25px', filter: tema === 'dark' ? 'invert(100%) ' : 'invert(0%) ' }} />

                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Estornar Duplicatas a Receber</span>
                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full px-3`}>

                    <div className={`grid grid-cols-12 gap-3 bg-white dark:bg-slate-600 py-3 h-full overflow-y-auto px-2`}>

                        <div className={`col-span-12 md:col-span-6 lg:col-span-5`}>

                            <div className={`grid grid-cols-12 gap-5`}>

                                <div className={`relative col-span-12`}>
                                    <input id="qtd_estornar_dup_receber" className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} type='text' placeholder=' ' disabled={true} value={qtdDupSelecionado} readOnly />
                                    <label htmlFor="qtd_estornar_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Qtde de Duplicatas</label>
                                </div>

                                <div className={`relative col-span-12`}>
                                    <input id="vl_estornar_dup_receber" className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} type='text' placeholder=' ' disabled={true} value={Funcoes.numberFormat(totSelecionado, 'decimal', 2, 2)} readOnly />
                                    <label htmlFor="vl_estornar_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do Estorno</label>
                                </div>

                                <div className={`relative col-span-12`}>
                                    <input id="senha_usuario_estornar_dup_receber" className={`${classInput} ${classInputDark}`} type='password' inputMode="text" placeholder=' ' autoComplete="off" value={senhaUsuario} onChange={handleChangeSenhaUsuario} />
                                    <label htmlFor="senha_usuario_estornar_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Senha do Usuário</label>
                                </div>

                                <div className={`relative col-span-12`}>
                                    <textarea id="motivo_estornar_dup_receber" className={`${classInput} ${classInputDark} h-[140px] resize-none`} placeholder=' ' maxLength={92} value={motivo} onChange={handleChangeMotivo} />
                                    <label htmlFor="motivo_estornar_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Motivo</label>
                                </div>

                            </div>

                        </div>

                        <div className={`col-span-12 md:col-span-6 lg:col-span-7 h-[500px] sm:h-[350px] border border-slate-400 dark:border-slate-700 rounded-sm px-2`}>

                            <div className={`grid grid-cols-12 gap-3`}>

                                <div className={`relative col-span-12 mt-1`}>

                                    <div className={`w-full`}>

                                        <ul className={`w-full h-full text-slate-800 dark:text-slate-200 dark:bg-slate-500`}>

                                            <li className={`h-10`}>

                                                <div className={`w-full flex flex-row h-10 font-mono`}>

                                                    <div className={`flex items-center w-[65%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Forma de Pagamento</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-[35%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Valor</span>
                                                    </div>

                                                </div>

                                            </li>

                                        </ul>

                                    </div>

                                    <div className={`overflow-auto h-full max-h-[1000px] scrollbar-custom dark:scrollbar-custom-dark`}>

                                        <div className={`w-full`}>

                                            <ul className={`w-full`}>

                                                {lanctoFormaPagList.length > 0 &&
                                                    lanctoFormaPagList.map((item) => (

                                                        <li key={item.id_fpagto} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>

                                                            <div className={`w-full flex flex-row h-[40px] font-mono text-black dark:text-slate-200`}>

                                                                <div className={`flex items-center w-[65%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{item.description}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[35%] break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                                </div>

                                                            </div>

                                                        </li>
                                                    ))
                                                }

                                            </ul>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button disabled={loading} onClick={fecharModal}
                        className={`${classbtColunasVermelho} max-w-[150px]`} >
                        CANCELAR
                    </button>

                    <button disabled={loading} onClick={handleLiquidarDuplicata}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `ESTORNAR` : 'AGUARDE'}
                    </button>

                </div>

            </div>

        </div>
    )
})